<template>
  <b-modal ref="sms-confirm-modal" hide-footer :title="modalTitle" no-close-on-backdrop no-close-on-esc centered>
    <div class="d-block text-center" v-if="smsConfirmable">
      <!--<h3>Hello From My Modal!</h3>-->
      <p>Bitte trage nun den SMS-Code ein. So können wir sichergehen, dass du es bist.</p>
      <form @submit.prevent>
        <div class="form-row" style="width: 215px; margin: 0 auto">
          <div class="mb-30 mt-30 col-12 floating-label">
            <span v-if="smsCodeInputFilledAndValidated" class="invalid-feedback">Bitte SMS Code eingeben! (6-stellig)</span>
<!--            v-if="valid('smsCode')"-->
            <input
                type="text"
                class="form-control"
                placeholder="SMS Code"
                name="smsCode"
                v-model="smsCode"
                @blur="smsCodeInputTouched = true"
            >
            <label>SMS Code</label>
<!--            v-validate="'required'"-->
          </div>
        </div>
        <br>
        <button type="submit"
                @click="checkSMSCode"
                class="btn btn-primary bg-gradient-primary mb-30"
                :disabled="!isSmsCodeInputFilled"
        >Absenden</button>
      </form>
    </div>


    <div v-else>
      <p>
        Hier scheint etwas schief gelaufen zu sein und eure E-Mail-Adresse wurde vorrübergehend gesperrt.
        <br>
        <br>
        Bitte registriert euch in 24 Stunden noch einmal neu oder verwendet eine andere E-Mail-Adresse.
        <br>
        <br>
        Vielen Dank für euer Verständnis! </p>
    </div>
  </b-modal>
</template>
<script>
import {apiValidateDigitalRegistration} from "../utils/api";


export default {
  props:[ 'optInCode', 'eMail', 'smsConfirmable' ],
  name: "smsAuthModal",
  data() {
    return {
      smsCode: '',
      smsCodeInputTouched: false,
    }
  },
  mounted(){
    this.showModal()
  },
  methods: {
    valid(name) {
      return this.fields[name] && this.fields[name].touched
    },
    checkSMSCode() {
      apiValidateDigitalRegistration(
          {
            "eMail": this.eMail,
            "optInCode": this.optInCode,
            "smsCode": this.smsCode
          }
      ) .then(response => {
        if (response.data.code === 0) {
          this.hideModal()
        } else if (response.data.code === 1)
          this.toast(
              " Keine passende Registrierung gefunden"
          );
        else if (response.data.code === 2)
          this.toast("OptinCode Überprüfung fehlgeschlagen");
        else if (response.data.code === 3)
          this.toast(
              "Code ist fehlerhaft"
          );
        else if (response.data.code === 4)
          this.toast("Die max. Eingabeversuche sind überschritten, Du kannst es nach 24 h erneut versuchen)");
        else if (response.data.code === 99)
          this.toast("Pflichtfeld nicht gefüllt");
      })
          .catch(e => {
            this.$store.commit("error", e);
          });
    },
    showModal() {
      this.$refs['sms-confirm-modal'].show()
    },
    hideModal() {
      this.$refs['sms-confirm-modal'].hide()
    },
    toast(text) {
      this.$toasted.error(text, {
        duration: 3000,
        position: "bottom-right"
      });
    },

  },
  computed: {
    completed() {
      return (
          Object.keys(this.fields).every(key => this.fields[key].validated) &&
          Object.keys(this.fields).every(key => this.fields[key].valid)
      );
    },

    isSmsCodeInputFilled(){
      return this.smsCode && this.smsCode.length === 6
    },
    smsCodeInputFilledAndValidated(){
      return this.smsCodeInputTouched && this.smsCode.length !== 6
    },

    modalTitle() {
      if(this.smsConfirmable) {
        return 'Authentifizierung'
      } else {
        return 'Bitte Entschuldigt!'
      }
    }
  }
};
</script>
